// Copyright 2024 - MinIO, Inc. All rights reserved.

import { Box } from "mds";
import React, { ReactNode } from "react";
import { CSSObject } from "styled-components";

const EFormSectionHeader = ({
  title,
  subtitle,
  sx,
  padded = false,
}: {
  title: string | ReactNode;
  subtitle?: string | ReactNode;
  sx?: CSSObject;
  padded?: boolean;
}) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        marginBottom: 24,
        paddingTop: padded ? 40 : "inherit",
        ...sx,
      }}
      className={"e-form-section-header"}
    >
      <Box
        sx={{
          fontSize: 20,
          fontWeight: 500,
          lineHeight: "28px",
        }}
      >
        {title}
      </Box>
      {subtitle && (
        <Box
          sx={{
            color: "#6B7280",
            fontSize: 14,
            fontWeight: 400,
            lineHeight: "20px",
            letterSpacing: "0.16px",
          }}
        >
          {subtitle}
        </Box>
      )}
    </Box>
  );
};
export default EFormSectionHeader;
